export * from './zr-angular.module';
